import { useAgentQuestionAction } from './actions/useAgentQuestionAction'
import { useConnectAppSendAction } from './actions/useConnectAppSendAction'
import { useExchangeVersionActions } from './actions/useExchangeVersionActions'
import { useMainAskBarPrefillAction } from './actions/useMainAskBarPrefillAction'
import { useRegenerateAssistantAction } from './actions/useRegenerateAssistantAction'
import { useSendEditVersionAction } from './actions/useSendEditVersionAction'
import { useSendMessageAction } from './actions/useSendMessageAction'
import { useClarificationStream } from './useClarificationStream'

/** @param {object} m */
export function useAppShellChatSendActions(m, onChatEvent) {
  const versions = useExchangeVersionActions(m)
  const { handleSendMessage } = useSendMessageAction(m, onChatEvent)
  const agentQuestion = useAgentQuestionAction(m, { handleSendMessage })
  // Cards submit through their own endpoint; this is what turns the accepted
  // response into the follow-up turn.
  useClarificationStream({
    displayThreadId: m.displayThreadId,
    setMessagesByThreadId: m.setMessagesByThreadId,
    handleSendMessage,
  })
  const { handleSendEditVersion } = useSendEditVersionAction(m, versions)
  const { handleRegenerateAssistantVersion } = useRegenerateAssistantAction(m, versions)
  const prefill = useMainAskBarPrefillAction(m)
  const connect = useConnectAppSendAction({ handleSendMessage })
  return {
    versions,
    handleSendMessage,
    handleSendEditVersion,
    handleRegenerateAssistantVersion,
    prefill,
    connect,
    agentQuestion,
  }
}
